
/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  // FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

var $firstSwipe = true;
timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];

      //hide current image
      $('.product-single__photos').show();
      $('.product-single__photos[data-image-id="'+newImg.id+'"]').hide();

      //switch product swiper to current image
      if($firstSwipe) {
        $firstSwipe = false;
      } else {
        var swiperIndex = $('.swiper-slide:not(.swiper-slide-duplicate)').index($('.swiper-slide:not(.swiper-slide-duplicate)[data-image-id="'+newImg.id+'"]'));
        swiperIndex = swiperIndex+1;

        if(!isNaN(swiperIndex)) {
          $('.swiper-pagination span').eq((swiperIndex-1)).trigger('click');
        }
      }

      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      if(variant.inventory_quantity <= 0 && variant.inventory_policy != 'deny') {
        $addToCartText.html("Preorder");
      } else {
        $addToCartText.html("Add to Cart");
      }
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("From" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');
    
	// change aria-expanded back to false
     if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);

/* Custom JavaScript starts here */
jQuery.fn.reverse = [].reverse;
jQuery.fn.random = function() {
  return this.eq(Math.floor(Math.random() * this.length));
}

function adjustPageContainer() {
  $('#PageContainer').css({ width:$windowWidth });
}

function adjustProductSummary() {
  var $summaryWidth = $('.product-single').width()*.35;
  if($windowWidth<=1024) $summaryWidth = $('.product-single').width()*.1;

  $('.product-summary').css({ width:$summaryWidth });
}

// "parallax" animation on scroll
function checkParallax() {
  $('.parallax').each(function() {
    var $parallaxItem = $(this);
    
    if(onScreen($parallaxItem)) {
      $parallaxItem.addClass('onscreen');
      setTimeout(function() {
        $parallaxItem.removeClass('parallax');
      }, 1500);
    } else {
      //$parallaxItem.removeClass('onscreen');
    }
  });
}

function onScreen($el) {
  if(($el.offset().top-$windowHeight) < $scrollTop) {
    return true;
  } else {
    return false;
  }
}

var $window = $(window),
    $windowWidth = $window.width(),
    $windowHeight = $window.height(),
    $scrollTop = $lastScrollTop = $window.scrollTop();
$(function() {
  //keep track of window dimensions
  $window.resize(function() {
    $windowWidth = $window.width();
    $windowHeight = $window.height();
  });

  $window.scroll(function() {
    $scrollTop = $window.scrollTop();

    //fixed navigation
    if($scrollTop>31) {
      $('body').addClass('fixed-nav');

      if($scrollTop>130 && $scrollTop > $lastScrollTop) {
        $('.site-header').addClass('hide-nav');
      } else {
        $('.site-header').removeClass('hide-nav');
      }
    } else {
      $('body').removeClass('fixed-nav');
    }

    $lastScrollTop = $scrollTop;

    checkParallax();
  });
  
  setTimeout(function() {
    /*if($scrollTop < $windowHeight) {
      $('.parallax').each(function() {
        if(onScreen($(this).parent()) || onScreen($(this))) {
          $(this).removeClass('parallax');
        }
      });
    }*/
    checkParallax();
  }, 250);

  //set product summary width
  adjustProductSummary();
  $window.resize(adjustProductSummary);

// Refactored November 2024
   var $availableSpace = $windowHeight-100;                                                                                                                                                                                                                                                                    
   var $productSummary = $('.product-summary');                                                                                                                                                                                                                                                                
                                                                                                                                                                                                                                                                                                               
   if($productSummary.length && $productSummary.height() < $availableSpace) {                                                                                                                                                                                                                                  
     $(window).scroll(function() {                                                                                                                                                                                                                                                                             
       var scrollTop = $(window).scrollTop();                                                                                                                                                                                                                                                                  
                                                                                                                                                                                                                                                                                                               
       if (scrollTop > 166 && scrollTop < $(document).height() - 499 - $productSummary.height()) {                                                                                                                                                                                                             
         $productSummary.css({                                                                                                                                                                                                                                                                                 
           position: 'fixed',                                                                                                                                                                                                                                                                                  
           top: '0px'                                                                                                                                                                                                                                                                                          
         });                                                                                                                                                                                                                                                                                                   
       } else {                                                                                                                                                                                                                                                                                                
         $productSummary.css({                                                                                                                                                                                                                                                                                 
           position: 'static'                                                                                                                                                                                                                                                                                  
         });                                                                                                                                                                                                                                                                                                   
       }                                                                                                                                                                                                                                                                                                       
     });                                                                                                                                                                                                                                                                                                       
   }                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                               
   /* set #pageContainer width */                                                                                                                                                                                                                                                                              
   adjustPageContainer();                                                                                                                                                                                                                                                                                      
   $window.resize(adjustPageContainer);                                                                                                                                                                                                                                                                        
                                                                                                                                                                                                                                                                                                               
   //add svg icons to links                                                                                                                                                                                                                                                                                    
   $('.arrow-right').each(function() {                                                                                                                                                                                                                                                                         
     $(this).append('<svg width="7" height="10" viewBox="0 0 7 10" xmlns="http://www.w3.org/2000/svg"><path d="M1 9.62l4.527-4.81L1 0" stroke="#9B9B9B" fill="none" fill-rule="evenodd"/></svg>');                                                                                                             
   });     
  $('.download').each(function() {
    $(this).prepend('<svg width="10" height="13" viewBox="0 0 10 13" xmlns="http://www.w3.org/2000/svg"><path d="M4.303 0v7.726L.707 4.13 0 4.835 4.802 9.64l4.804-4.804-.708-.707-3.595 3.596V0h-1zM0 13h9.606v-1H0v1z" fill="#9B9B9B" fill-rule="evenodd"/></svg>');
  });
  $('.play').each(function() {
    $(this).prepend('<svg width="8" height="10" viewBox="0 0 8 10" xmlns="http://www.w3.org/2000/svg"><path d="M7.778 5L0 10V0" fill="#9B9B9B" fill-rule="evenodd"/></svg>');
  });

  /* close drawer when user clicks drawer mask */
  $('.drawer-mask').click(function(e) {
    e.preventDefault();

    if(timber.RightDrawer.drawerIsOpen) timber.RightDrawer.close();
    if(timber.LeftDrawer.drawerIsOpen) timber.LeftDrawer.close();
  });

  /* fadein gallery grid items on load */
  $('.article.gallery-grid img').imagesLoaded(function() {
//     TweenMax.set($('.article.gallery-grid'), { y:10 });
//     TweenMax.to($('.article.gallery-grid'), 0.3, { opacity:1/*, y:0*/ });
  });

 /* fadein collection feature image on load */
  $('.collection-feature img').imagesLoaded(function() {
//     TweenMax.set($('.collection-feature'), { y:10 });
//     TweenMax.to($('.collection-feature'), 0.3, { opacity:1/*, y:0*/ });
  });

  //add image captions to blog posts
//   $('article .rte img').each(function() {
//     var alt = $(this).attr('alt');
//     //if(alt != ''){
//       if($(this).parent().is('p')) $(this).unwrap();
//       $(this).wrap('<figure />');
//       $(this).parent().append('<figcaption class="figcap">'+alt+'</figcaption>');
//     //}
//   });

  /* display featured images */
//   $('.feature-image img').imagesLoaded(function() {
//     var $img = $('.feature-image img').random();

//     $img.css({ display:'block' });
//     $('.feature-image').css({ height:'auto' });
//     $img.animate({ opacity:1 }, function() {
//       checkParallax();
//     });
//   });

  /* adjust homepage callouts */
  $('.homepage-callout img').imagesLoaded(function() {
    adjustHomepageCallouts();
    $window.resize(adjustHomepageCallouts);
  });

  /* adjust collection modules */
  $('.collection-module img').imagesLoaded(function() {
    adjustCollectionModules();
    $window.resize(adjustCollectionModules);
  });

  /* toggle "hover" class on homepage callouts */
  /*$('.homepage-callout h2 a').mouseover(function() {
    $(this).parents('.homepage-callout').find('.homepage-callout-image a').addClass('hover');
  });
  $('.homepage-callout h2 a').mouseout(function() {
    $(this).parents('.homepage-callout').find('.homepage-callout-image a').removeClass('hover');
  });*/

  /* toggle "hover" class on collection callouts */
  /*$('.collection-module .collection-title a').mouseover(function() {
    $(this).parents('.collection-module').find('.collection-image a').addClass('hover');
  });
  $('.collection-module .collection-title a').mouseout(function() {
    $(this).parents('.collection-module').find('.collection-image a').removeClass('hover');
  });*/

  /* collection list animations */
  /*if($('.collection-module').length>0 && !$('html').hasClass('supports-touch')) {
    $('.collection-module a').each(function() {
      var $collectionModule = $(this),
          $pegs = $collectionModule.find('.collection-animation span:not(:first)'),
          $reversePegs = $collectionModule.find('.collection-animation span:not(:first)').reverse();

      $collectionModule.mouseover(function() {
        TweenMax.killTweensOf($reversePegs);
        TweenMax.staggerTo($pegs, 0.3, { opacity:1 }, 0.1);
      });
      $collectionModule.mouseout(function() {
        TweenMax.killTweensOf($pegs);
        TweenMax.staggerTo($reversePegs, 0.3, { opacity:0 }, 0.1);
      });
    });
  } else */if($('.collection-module').length>0) {
    setTimeout(triggerCollectionAnimations, 400);
    $window.scroll(triggerCollectionAnimations);
  }

  /* collection detail swipers */
  if($('.showcase .swiper-container .swiper-slide').length>1) {
    $('.swiper-button-next, .swiper-button-prev').show();
    $('.swiper-container').swiper({
      loop: true,
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      pagination: '.swiper-pagination',
      paginationClickable: true
    });
  }

  /* product detail swipers */
  if($('.swiper-container.product-swiper .swiper-slide').length>1) {
    $('.swiper-container.product-swiper').swiper({
      loop: true,
      pagination: '.swiper-pagination',
      paginationClickable: true
    });
  }

  /* back to top */
  $('.back-to-top').click(function(e) {
    e.preventDefault();

    $('html, body').animate({ scrollTop:0 });
  });

  /* checkbox styles */
  $('input[type="checkbox"]').each(function() {
    if($(this).next().is('label')) {
      $(this).hide();
      $(this).next().prepend('<svg width="18" height="16" viewBox="0 0 18 16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h16v16H0z"/><mask id="b" x="0" y="0" width="16" height="16" fill="#fff"><use xlink:href="#a"/></mask></defs><g fill="none" fill-rule="evenodd"><use stroke="#000" mask="url(#b)" stroke-width="2" fill="#FFF" xlink:href="#a"/><path class="checkbox" fill="#000" d="M8 12L3 7l2-2 3 3 8-8 2 2"/></g></svg>');
    }
  });

  /* swatch label touch event fix */
  $('#radioSelect label').click(function() {
    $(this).prev().trigger('click');
  });
});

function triggerCollectionAnimations() {
  $('.collection-module .collection-animation').each(function() {
    var $collectionModule = $(this),
        $pegs = $collectionModule.find('span'),
        $reversePegs = $collectionModule.find('span').reverse();

    if($collectionModule.hasClass('animated')) {
      if(!isElementInViewport($pegs, false)) {
        TweenMax.killTweensOf($pegs);
        TweenMax.staggerTo($reversePegs, 0.3, { opacity:0 }, 0.1);
        $collectionModule.removeClass('animated');
      }
    } else if(isElementInViewport($pegs, true)) {
      if(!$collectionModule.hasClass('animated')) {
        TweenMax.killTweensOf($reversePegs);
        TweenMax.staggerTo($pegs, 0.3, { opacity:1 }, 0.1);

        $collectionModule.addClass('animated');
      }
    }
    if(isElementInViewport($pegs, true)) {
      if(!$collectionModule.hasClass('animated')) {
        TweenMax.killTweensOf($reversePegs);
        TweenMax.staggerTo($pegs, 0.3, { opacity:1 }, 0.1);

        $collectionModule.addClass('animated');
      }
    } else {
      if($collectionModule.hasClass('animated')) {
        TweenMax.killTweensOf($pegs);
        TweenMax.staggerTo($reversePegs, 0.3, { opacity:0 }, 0.1);
        $collectionModule.removeClass('animated');
      }
    }
  });
}

function isElementInViewport(el, collectionAnimation) {
  if(typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }
  var rect = el.getBoundingClientRect();
//   console.log(rect);

  if(collectionAnimation) {
    return (
      rect.top >= ((window.innerHeight*.25) || (document.documentElement.clientHeight*.25)) &&
      rect.left >= 0 &&
      rect.bottom <= ((window.innerHeight*.75) || (document.documentElement.clientHeight*.75)) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  } else {
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
}

function adjustHomepageCallouts() {
  $('.homepage-callout').each(function() {
    var $image = $(this).find('.homepage-callout-image img'),
        $title = $(this).find('.homepage-callout-copy');

    $title.css({ height:$image.height() }).animate({ opacity:1 });
  });
}

function adjustCollectionModules() {
  $('.collection-module').each(function() {
    var $image = $(this).find('.collection-image img'),
        $title = $(this).find('.collection-title');

    $title.css({ height:$image.height() }).animate({ opacity:1 });
  });
}


 